import React, { Component } from 'react'
import { Divider, Form, Grid, Header } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import Section from '../Inputs/Section'
import { CasseVideModel, FromTo, FuiteEtanche, ReussiEchec } from '../../../utils/FormSelectHelper'
import Input from '../Inputs/Input'
import Select from '../Inputs/Select'
import TextArea from '../Inputs/TextArea'
import { Line } from 'react-chartjs-2'
import { autorun } from 'mobx'
import SelectMultiple from '../Inputs/SelectMultiple'
import { inject, observer } from 'mobx-react'

@inject('eventsStore')
@observer
class RIGDR1000 extends Component {
  static propTypes = {
    equipment: PropTypes.instanceOf(FormEntry),
    eventsStore: PropTypes.any
  }

  state = {
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      },
      tooltips: {
        enabled: true
      },
      hover: {
        animationDuration: 0
      }
    },
    data: {
      datasets: [{
        label: 'Perte de pression',
        data: [],
        backgroundColor: 'rgba(243, 19, 179, 0.7)',
        borderColor: 'rgb(243, 19, 179)',
        fill: false,
        borderWidth: 2,
        tension: 0.2
      }, {
        label: 'GPM',
        data: [],
        backgroundColor: 'rgba(3, 31, 74, 0.7)', // #031f4b
        borderColor: 'rgb(3, 31, 74)', // #031f4b
        fill: false,
        borderWidth: 2,
        tension: 0.3
      }],
      labels: []
    }
  }

  componentDidMount () {
    const { equipment, eventsStore } = this.props
    const { data } = this.state
    const { event } = eventsStore
    if (!equipment.hasValue('numeroSerie') && !equipment.readonly) {
      equipment.updateValue('numeroSerie', event.user.serial_number)
    }
    this.autorun = autorun(() => {
      const newData = data
      newData.datasets[0].data = []
      if (equipment.getValue('pertePression0')) {
        newData.datasets[0].data.push({ x: 0, y: parseInt(equipment.getValue('pertePression0')) })
        if (!newData.labels.includes(0)) {
          newData.labels.push(0)
        }
      }
      if (equipment.getValue('pertePression50')) {
        newData.datasets[0].data.push({ x: 50, y: parseInt(equipment.getValue('pertePression50')) })
        if (!newData.labels.includes(50)) {
          newData.labels.push(50)
        }
      }
      if (equipment.getValue('pertePression100')) {
        newData.datasets[0].data.push({ x: 100, y: parseInt(equipment.getValue('pertePression100')) })
        if (!newData.labels.includes(100)) {
          newData.labels.push(100)
        }
      }
      newData.datasets[1].data = []
      for (let i = 1; i <= 7; i++) {
        if (equipment.getValue(`tableauCapacite${i}`) && equipment.getValue(`tableauPerteCharge${i}`)) {
          if (!newData.labels.includes(parseInt(equipment.getValue(`tableauCapacite${i}`)))) {
            newData.labels.push(parseInt(equipment.getValue(`tableauCapacite${i}`)))
          }
          newData.datasets[1].data.push({
            x: parseInt(equipment.getValue(`tableauCapacite${i}`)),
            y: parseInt(equipment.getValue(`tableauPerteCharge${i}`))
          })
        }
      }
      newData.labels = newData.labels.sort((a, b) => a - b)
      this.setState({ data: newData })
    })
  }

  componentWillUnmount () {
    this.autorun()
  }

  render () {
    const { equipment } = this.props
    const { options, data } = this.state

    return (
      <>
        <Form>
          <Section title={(<Header as='h2'>RAPPORT D'ESSAI ET DE VÉRIFICATIONS</Header>)} name='dar2cr_so' equipment={equipment}>
            <Grid>
              <Grid.Row className='compact'>
                <Grid.Column>
                  <Header as='h5' textAlign='center'>DISPOSITIF ANTIREFOULEMENT À DEUX CLAPETS DAr2CR DE RETENUE ET ROBINETS, ET CASSE-VIDE À PRESSION C-VP</Header>
                  <Form.Group widths='equal'>
                    <Input name='numVerificateur' formEntry={equipment} label='Numéro du vérificateur' />
                    <Select
                      name='marqueMaterielEssai' formEntry={equipment} options={[
                        { value: 'wilkins', text: 'Wilkins' },
                        { value: 'watts', text: 'Watts' },
                        { value: 'midwestInstrument', text: 'Midwest Instrument' },
                        { value: 'autre', text: 'Autre' }
                      ]}
                      isRequired label="Marque du matériel d'essai"
                    />
                    <Input name='modele' formEntry={equipment} label='Modèle' />
                    <Input name='numeroSerie' formEntry={equipment} label='Numéro de série' />
                    <Input name='DateEtalonnage' formEntry={equipment} label="Date d'étalonnage" type='date' />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2} className='compact'>
                <Grid.Column>
                  <Header as='h5' textAlign='center'>DISPOSITIF ANTIREFOULEMENT À 2 CLAPETS DE RETENUS</Header>
                  <Form.Group widths='equal'>
                    <Select
                      name='dispositifAntirefoulementTypeDispositifDar2CR' formEntry={equipment} options={[
                        { value: 'darpr', text: 'DArPR' },
                        { value: 'dar2cr', text: 'DAr2CR' },
                        { value: 'cvp', text: 'C-VP' },
                        { value: 'cvpad', text: 'CVPAD' }
                      ]}
                      isRequired label='Type de dar'
                    />
                    <Select
                      name='dispositifAntirefoulementMarqueDuDispositif' formEntry={equipment} options={[
                        { value: 'wilkins', text: 'Wilkins' },
                        { value: 'watts', text: 'Watts' },
                        { value: 'apollo', text: 'Apollo' },
                        { value: 'ames', text: 'Ames' },
                        { value: 'autre', text: 'Autre' }
                      ]}
                      isRequired label='Marque du dispositif'
                    />
                  </Form.Group>
                </Grid.Column>
                <Grid.Column>
                  <Header as='h5' textAlign='center'>CASSE-VIDE À RESSION</Header>
                  <Form.Group widths='equal'>
                    <Select name='casseVideModele' formEntry={equipment} options={CasseVideModel()} label='Modèle' />
                    <Input name='casseVideNumeroSerie' formEntry={equipment} label='Numéro de série' />
                    <Select
                      name='casseVideRessionDiametre' formEntry={equipment} options={[
                        { value: '1/4', text: '¼' },
                        { value: '1/2', text: '½' },
                        { value: '3/4', text: '¾' },
                        { value: '1', text: '1' },
                        { value: '1 1/4', text: '1 ¼' },
                        { value: '1 1/2', text: '1 ½' },
                        { value: '1 3/4', text: '1 ¾' },
                        { value: '2', text: '2' },
                        { value: '2 1/2', text: '2 ½' },
                        { value: '3', text: '3' },
                        { value: '4', text: '4' },
                        { value: '6', text: '6' },
                        { value: '8', text: '8' },
                        { value: '10', text: '10' },
                        { value: '12', text: '12' }
                      ]}
                      isRequired label='Diamètre (1/4 à 12 pouces)'
                    />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className='compact'>
                <Grid.Column>
                  <Input name='emplacementDispositif' formEntry={equipment} label='Emplacement du dispositif' />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2} className='compact'>
                <Grid.Column textAlign='center' verticalAlign='middle'>
                  <Header as='h5'>Essai</Header>
                </Grid.Column>
                <Grid.Column textAlign='center' verticalAlign='middle'>
                  <Header as='h5'>Pression de la conduite pendant l’essai</Header>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2} className='compact'>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <Select
                      name='typeEssai' formEntry={equipment} options={[
                        { value: 'initiale', text: 'Initiale' },
                        { value: 'annuel', text: 'Annuel' },
                        { value: 'travaux', text: 'Travaux' }
                      ]}
                      isRequired label="Type d'essai"
                    />
                    <Input name='typeEssaiDateEssai' type='date' formEntry={equipment} label={"Date de l'essai"} />
                  </Form.Group>
                </Grid.Column>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <Select name='typeEssaiPressionKPa' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='KPa' />
                    <Select name='typeEssaiPressionLbPo2' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='lb/po2' />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Section>
          <Grid>
            <Grid.Row columns={1}>
              <Grid.Column textAlign='center'>
                <Header as='h1'>ESSAI</Header>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Section title={(<Header as='h2'>DISPOSITIF À 2 CLAPETS DE RETENUE ET ROBINETS D'ARRÊTS</Header>)} name='dr1EReV' equipment={equipment}>
            <Grid>
              <Grid.Row columns={2} className='compact'>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>Clapet no.1
                      </Header>
                    </div>
                    <Select name='essaiClapetno1SensNormal' formEntry={equipment} options={FuiteEtanche()} label='Sens normal' />
                    <Select name='essaiClapetno1ContreSens' formEntry={equipment} options={FuiteEtanche()} label='Contre-sens' />
                  </Form.Group>
                </Grid.Column>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>Chute de pression dans le clapet</Header>
                    </div>
                    <Select name='essaiClapetno1ChutePressionkpa' formEntry={equipment} options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} label='kPa' />
                    <Select name='essaiClapetno1ChutePressionlbpo2' formEntry={equipment} options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} label='lb/po2' />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2} className='compact'>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>Clapet no.2
                      </Header>
                    </div>
                    <Select name='essaiClapetno2SensNormal' formEntry={equipment} options={FuiteEtanche()} label='Sens normal' />
                    <Select name='essaiClapetno2ContreSens' formEntry={equipment} options={FuiteEtanche()} label='Contre-sens' />
                  </Form.Group>
                </Grid.Column>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>Chute de pression dans le clapet</Header>
                    </div>
                    <Select name='essaiClapetno2ChutePressionkpa' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='kPa' />
                    <Select name='essaiClapetno2ChutePressionlbpo2' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='lb/po2' />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2} className='compact'>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>Pression différentielle dans le 1er clapet (essai d'écoulement nul)</Header>
                    </div>
                    <Select name='pressionDifferentialKpa' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='kPa' />
                    <Select name='pressionDifferentialLbPo2' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='lb/po2' />
                  </Form.Group>
                </Grid.Column>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <Select
                      name='robinetArretno2' formEntry={equipment} options={[
                        { value: 'etanche', text: 'Étanche' },
                        { value: 'fuites', text: 'Fuites' }
                      ]} label="Robinet d'arrêt no.2"
                    />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2} className='compact'>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>Moins le point d'ouverture</Header>
                    </div>
                    <Select name='moinsPointOuvertureKpa' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='kPa' />
                    <Select name='moinsPointOuvertureLbPo2' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='lb/po2' />
                  </Form.Group>
                </Grid.Column>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>Soupape de décharge à pression différentielle</Header>
                    </div>
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2} className='compact'>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>de la soupape de décharge</Header>
                    </div>
                    <Select name='soupapeDechargeKpa' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='kPa' />
                    <Select name='soupapeDechargeLbPo2' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='lb/po2' />
                  </Form.Group>
                </Grid.Column>
                <Grid.Column>
                  <Form.Group widths='equal'>
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>ouvert à</Header>
                    </div>
                    <Select name='robinetArretOuvertKpa' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='kPa' />
                    <Select name='robinetArretOuvertLbPo2' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='lb/po2' />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={1}>
                <Grid.Column verticalAlign='middle'>
                  <Select name='essaiClapetResultatEssai' formEntry={equipment} options={ReussiEchec()} label="Résultat d'essai" />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Section>
          <Section title={(<Header as='h2'>CASSE-VIDE À PRESSION</Header>)} name='dr1ECVP' equipment={equipment}>
            <Grid>
              <Grid.Row columns={1}>
                <Grid.Column verticalAlign='middle'>
                  <Form.Group widths='equal'>
                    <Select
                      name='essaiCasseVidePressionAdmissionAir' formEntry={equipment} options={[
                        { value: 'ouverture', text: 'Ouverture' },
                        { value: 'defaillance', text: 'Défaillance' }
                      ]} label={"Admission d'air"}
                    />
                    <Select name='essaiCasseVidePressionAdmissionAirKpa' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='kPa' />
                    <Select name='essaiCasseVidePressionAdmissionAirlbpo2' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='lb/po2' />
                    <Select
                      name='essaiCasseVidePressionAdmissionAirClapetRetenu' formEntry={equipment} options={FuiteEtanche()} label='Clapet de retenu'
                    />
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>Chute de pression dans le clapet</Header>
                    </div>
                    <Select name='essaiCasseVideChutePressionClapetKpa' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='kPa' />
                    <Select name='essaiCasseVideChutePressionClapetlbpo2' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='lb/po2' />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={1}>
                <Grid.Column verticalAlign='middle'>
                  <Select name='essaiCasseVideChutePressionClapetResultatEssai' formEntry={equipment} options={ReussiEchec()} label="Résultat d'essai" />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={1}>
                <Grid.Column verticalAlign='middle'>
                  <Header as='h5'>EN CAS D'ÉCHEC AU COURS DE L'ESSAI DU DISPOSITIF, POUR TOUTE RAISON, COMPLÉTER CETTE SECTION ET COCHER LES CASES
                    CI-DESSOUS POUR TOUTES RÉPARATIONS
                  </Header>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={1}>
                <Grid.Column verticalAlign='middle'>
                  <Form.Group widths='equal'>
                    <TextArea rows={6} name='causeDefaillance' formEntry={equipment} label='Cause de défaillance (si visible):' />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Section>
          <Section title={(<Header as='h2'>REMPLACEMENT</Header>)} name='dr1ER' equipment={equipment}>
            <Grid>
              <Grid.Row columns={3}>
                <Grid.Column textAlign='center' verticalAlign='middle' className='two-third'>
                  <Header as='h5'>Dispositif à 2 clapets de retenue et robinets</Header>
                </Grid.Column>
                <Grid.Column />
              </Grid.Row>
              <Grid.Row columns={3}>
                <Grid.Column textAlign='center' verticalAlign='middle'>
                  <Header as='h5'>Clapet de retenue no.1</Header>
                </Grid.Column>
                <Grid.Column textAlign='center' verticalAlign='middle'>
                  <Header as='h5'>Clapet de retenue no.2</Header>
                </Grid.Column>
                <Grid.Column textAlign='center' verticalAlign='middle'>
                  <Header as='h5'>Casse-Vide à pression</Header>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={3}>
                <Grid.Column verticalAlign='middle'>
                  <SelectMultiple
                    formEntry={equipment} options={[
                      { value: 'clapetRetenuNo1Nettoye', text: 'Nettoyé' },
                      { value: 'clapetRetenuNo1Disque', text: 'Disque' },
                      { value: 'clapetRetenuNo1Ressort', text: 'Ressort' },
                      { value: 'clapetRetenuNo1Guide', text: 'Guide' },
                      { value: 'clapetRetenuNo1BagueRetenuGoupille', text: 'Bague de retenue de la goupille' },
                      { value: 'clapetRetenuNo1GoupilleChaniere', text: 'Goupille de charnière' },
                      { value: 'clapetRetenuNo1Siege', text: 'Siège' },
                      { value: 'clapetRetenuNo1membrane', text: 'Membrane' },
                      { value: 'clapetRetenuNo1Autre', text: 'Autre (décrire ci-haut)' }
                    ]}
                  />
                </Grid.Column>
                <Grid.Column verticalAlign='middle'>
                  <SelectMultiple
                    formEntry={equipment} options={[
                      { value: 'clapetRetenuNo2Nettoye', text: 'Nettoyé' },
                      { value: 'clapetRetenuNo2Disque', text: 'Disque' },
                      { value: 'clapetRetenuNo2Ressort', text: 'Ressort' },
                      { value: 'clapetRetenuNo2Guide', text: 'Guide' },
                      { value: 'clapetRetenuNo2BagueRetenuGoupille', text: 'Bague de retenue de la goupille' },
                      { value: 'clapetRetenuNo2GoupilleChaniere', text: 'Goupille de charnière' },
                      { value: 'clapetRetenuNo2Siege', text: 'Siège' },
                      { value: 'clapetRetenuNo2membrane', text: 'Membrane' },
                      { value: 'clapetRetenuNo2Autre', text: 'Autre (décrire ci-haut)' }
                    ]}
                  />
                </Grid.Column>
                <Grid.Column verticalAlign='middle'>
                  <SelectMultiple
                    formEntry={equipment} options={[
                      { value: 'clapetRetenuCasseVidePressionNettoye', text: 'Nettoyé' },
                      { value: 'clapetRetenuCasseVidePressionDisqueOrificeVentilation', text: 'Disque, orifice de ventilation' },
                      { value: 'clapetRetenuCasseVidePressionRessortOV', text: 'Ressort, orifice de ventilation' },
                      { value: 'clapetRetenuCasseVidePressionDisqueChampignon', text: 'Disque (champignon)' },
                      { value: 'clapetRetenuCasseVidePressionBagueRetenu', text: 'Bague de retenue' },
                      { value: 'clapetRetenuCasseVidePressionRessort', text: 'Ressort' },
                      { value: 'clapetRetenuCasseVidePressionDisque', text: 'Disque' },
                      { value: 'clapetRetenuCasseVidePressionGuide', text: 'Guide' },
                      { value: 'clapetRetenuCasseVidePressionAutre', text: 'Autre (décrire ci-haut' }
                    ]}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Section>
          <Grid>
            <Grid.Row columns={1}>
              <Grid.Column textAlign='center'>
                <Header as='h1'>CONTRE-ESSAI</Header>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Section title={(<Header as='h2'>DISPOSITIF À 2 CLAPETS DE RETENUE ET ROBINETS D'ARRÊTS</Header>)} name='dr1CEReV' equipment={equipment}>
            <Grid>
              <Grid.Row columns={1}>
                <Grid.Column verticalAlign='middle'>
                  <Form.Group widths='equal'>
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>Clapet no.1</Header>
                    </div>
                    <Select name='contreEssaiClapetno1SensNormal' formEntry={equipment} options={FuiteEtanche()} label='Sens normal' />
                    <Select name='contreEssaiClapetno1ContreSens' formEntry={equipment} options={FuiteEtanche()} label='Contre-sens' />
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>Chute de pression dans le clapet</Header>
                    </div>
                    <Select name='contreEssaiClapetno1ChutePressionkpa' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='kPa' />
                    <Select name='contreEssaiClapetno1ChutePressionlbpo2' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='lb/po2' />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={1}>
                <Grid.Column verticalAlign='middle'>
                  <Form.Group widths='equal'>
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>Clapet no.2</Header>
                    </div>
                    <Select name='contreEssaiClapetno2SensNormal' formEntry={equipment} options={FuiteEtanche()} label='Sens normal' />
                    <Select name='contreEssaiClapetno2ContreSens' formEntry={equipment} options={FuiteEtanche()} label='Contre-sens' />
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>Chute de pression dans le clapet</Header>
                    </div>
                    <Select name='contreEssaiClapetno2ChutePressionkpa' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='kPa' />
                    <Select name='contreEssaiClapetno2ChutePressionlbpo2' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='lb/po2' />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={1}>
                <Grid.Column verticalAlign='middle'>
                  <Select name='contreEssaiClapetResultatContreEssai' formEntry={equipment} options={ReussiEchec()} label='Résultat du contre-essai' />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Section>
          <Section title={(<Header as='h2'>CASSE-VIDE À PRESSION</Header>)} name='dr1CECVaP' equipment={equipment}>
            <Grid>
              <Grid.Row columns={1}>
                <Grid.Column verticalAlign='middle'>
                  <Form.Group widths='equal'>
                    <Select
                      name='contreEssaiCasseVidePressionAdmissionAir' formEntry={equipment} options={[
                        { value: 'ouverture', text: 'Ouverture' },
                        { value: 'defaillance', text: 'Défaillance' }
                      ]} label={"Admission d'air"}
                    />
                    <Select name='contreEssaiCasseVidePressionAdmissionAirKpa' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='kPa' />
                    <Select name='contreEssaiCasseVidePressionAdmissionAirlbpo2' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='lb/po2' />
                    <Select
                      name='contreEssaiCasseVidePressionAdmissionAirClapetRetenu' formEntry={equipment} options={FuiteEtanche()} label='Clapet de retenu'
                    />
                    <div className='field' style={{ alignSelf: 'center' }}>
                      <Header as='h5'>Chute de pression dans le clapet</Header>
                    </div>
                    <Select name='contreEssaiCasseVideChutePressionClapetKpa' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='kPa' />
                    <Select name='contreEssaiCasseVideChutePressionClapetlbpo2' options={[...FromTo(0, 10, 0.1, 1), ...FromTo(11, 150)]} formEntry={equipment} label='lb/po2' />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={1}>
                <Grid.Column verticalAlign='middle'>
                  <Select name='contreEssaiCasseVideChutePressionClapetResultatContreEssai' formEntry={equipment} options={ReussiEchec()} label='Résultat du contre-essai' />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={1}>
                <Grid.Column verticalAlign='middle'>
                  <Form.Group widths='equal'>
                    <TextArea rows={3} name='observations' formEntry={equipment} label='Observations:' />
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Section>
          <Section title={(<Header as='h2'>ESSAI D'ÉCOULEMENT</Header>)} name='ede_so' equipment={equipment}>
            <Grid>
              <Grid.Row columns={3}>
                <Grid.Column className='compact'>
                  <Form.Group inline>
                    Perte de pression 0 %(<Input name='pertePression0GPM' width={3} formEntry={equipment} />= 0% GPM)
                  </Form.Group>
                </Grid.Column>
                <Grid.Column className='compact'>
                  <Form.Group inline>
                    Perte de pression 50 %(<Input name='pertePression50GPM' width={3} formEntry={equipment} />= 50% GPM)
                  </Form.Group>
                </Grid.Column>
                <Grid.Column className='compact'>
                  <Form.Group inline>
                    Perte de pression 100 %(<Input name='pertePression100GPM' width={3} formEntry={equipment} />= 100% GPM)
                  </Form.Group>
                </Grid.Column>
                <Grid.Column className='compact'>
                  <Select name='pertePression0' formEntry={equipment} options={FromTo(0, 10)} />
                </Grid.Column>
                <Grid.Column className='compact'>
                  <Select name='pertePression50' formEntry={equipment} options={FromTo(0, 10)} />
                </Grid.Column>
                <Grid.Column className='compact'>
                  <Select name='pertePression100' formEntry={equipment} options={FromTo(0, 10)} />
                </Grid.Column>
              </Grid.Row>
              <Divider />
              <Grid.Row columns={8}>
                <Grid.Column className='compact' />
                <Grid.Column className='compact' />
                <Grid.Column className='compact' />
                <Grid.Column className='compact' />
                <Grid.Column className='compact'>SORTIE</Grid.Column>
                <Grid.Column className='compact' />
                <Grid.Column className='compact' />
                <Grid.Column className='compact' />
              </Grid.Row>
              <Grid.Row columns={8}>
                <Grid.Column className='compact'>Pression décharge PSI</Grid.Column>
                <Grid.Column className='compact'>Pression succion PSI</Grid.Column>
                <Grid.Column className='compact'>Perte de charge</Grid.Column>
                <Grid.Column className='compact'>No</Grid.Column>
                <Grid.Column className='compact'>Grosseur</Grid.Column>
                <Grid.Column className='compact'>Pression Pitot</Grid.Column>
                <Grid.Column className='compact'>Gallons par Minute</Grid.Column>
                <Grid.Column className='compact'>% Capacité NOMINALE</Grid.Column>
              </Grid.Row>
              {[...Array(7)].map((x, i) => {
                const index = ++i
                return (
                  <Grid.Row key={`tableRow${index}`} columns={8} textAlign='center' className='compact'>
                    <Grid.Column><Input name={`tableauDecharge${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauSuccion${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauPerteCharge${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauNo${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauGrosseur${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauPressionPitot${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauGallonsMinute${index}`} formEntry={equipment} /></Grid.Column>
                    <Grid.Column><Input name={`tableauCapacite${index}`} formEntry={equipment} /></Grid.Column>
                  </Grid.Row>
                )
              })}
              <Grid.Row>
                <Grid.Column>
                  <Line data={data} options={options} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Divider className='dashed' />
            <Form.Group widths='equal'>
              <Input type='date' name='essaiPerformanceDate' formEntry={equipment} label='Date' />
              <Select
                name='essaiConform' formEntry={equipment} options={[
                  { value: 'conforme', text: 'Conforme' },
                  { value: 'nonconforme', text: 'Non-conforme' }
                ]} label='Conforme'
              />
            </Form.Group>
          </Section>
        </Form>
      </>
    )
  }
}

RIGDR1000.fieldsRequired = [
  {
    section: 'dar2cr_so',
    fields: [
      'marqueMaterielEssai',
      'dispositifAntirefoulementTypeDispositifDar2CR',
      'casseVideRessionDiametre',
      'typeEssai'
    ]
  }
]
export default RIGDR1000
